import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

export const api = {
  session: () => http.post("/session").then((r) => r.data),
  listJobs: (userId) => http.get("/jobs", { params: { user_id: userId } }).then((r) => r.data),
  createJob: (userId, name, category, subject) => http.post("/jobs", { user_id: userId, name, category, subject }).then((r) => r.data),
  getJob: (id) => http.get(`/jobs/${id}`).then((r) => r.data),
  updateJob: (id, body) => http.put(`/jobs/${id}`, body).then((r) => r.data),
  deleteJob: (id) => http.delete(`/jobs/${id}`).then((r) => r.data),
  uploadFile: (id, file, sheet) => {
    const fd = new FormData();
    fd.append("file", file);
    if (sheet !== undefined && sheet !== null) fd.append("sheet", sheet);
    return http.post(`/jobs/${id}/files`, fd).then((r) => r.data);
  },
  paste: (id, name, text) => http.post(`/jobs/${id}/paste`, { name, text }).then((r) => r.data),
  deleteFile: (id, slot) => http.delete(`/jobs/${id}/files/${slot}`).then((r) => r.data),
  renameFile: (id, slot, name) => http.put(`/jobs/${id}/files/${slot}`, { name }).then((r) => r.data),
  pdfPreview: (id, file) => { const fd = new FormData(); fd.append("file", file); return http.post(`/jobs/${id}/pdf-preview`, fd).then((r) => r.data); },
  addTable: (id, name, columns, rows) => http.post(`/jobs/${id}/add-table`, { name, columns, rows }).then((r) => r.data),
  setFileFilter: (id, slot, row_filter, dedup) => http.put(`/jobs/${id}/files/${slot}/filter`, { row_filter, dedup }).then((r) => r.data),
  match: (id, levels, include_unmatched = true) =>
    http.post(`/jobs/${id}/match`, { levels, include_unmatched }).then((r) => r.data),
  suggestKeys: (id) => http.post(`/jobs/${id}/suggest-keys`).then((r) => r.data),
  verify: (id, tool, params, rowIds) => http.post(`/jobs/${id}/verify`, { tool, params, row_ids: rowIds || null }).then((r) => r.data),
  aiTool: (id, request, baseToolId) => http.post(`/jobs/${id}/ai-tool`, { request, base_tool_id: baseToolId || null }).then((r) => r.data),
  applyAiTool: (id, toolId, params, rowIds) => http.post(`/jobs/${id}/apply-ai-tool`, { tool_id: toolId, params: params || {}, row_ids: rowIds || null }).then((r) => r.data),
  renameAiTool: (id, toolId, name, explanation) => http.put(`/jobs/${id}/ai-tool/${toolId}`, { name, explanation }).then((r) => r.data),
  deleteAiTool: (id, toolId) => http.delete(`/jobs/${id}/ai-tool/${toolId}`).then((r) => r.data),
  duplicateAiTool: (id, toolId) => http.post(`/jobs/${id}/ai-tool/${toolId}/duplicate`).then((r) => r.data),
  manualMatch: (id, body) => http.post(`/jobs/${id}/manual-match`, body).then((r) => r.data),
  setRating: (id, rowId, rating) => http.post(`/jobs/${id}/set-rating`, { row_id: rowId, rating }).then((r) => r.data),
  setRatingBulk: (id, rowIds, rating) => http.post(`/jobs/${id}/set-rating-bulk`, { row_ids: rowIds, rating }).then((r) => r.data),
  undo: (id) => http.post(`/jobs/${id}/undo`).then((r) => r.data),
  redo: (id) => http.post(`/jobs/${id}/redo`).then((r) => r.data),
  unpublish: (id, userId) => http.post(`/jobs/${id}/unpublish`, { user_id: userId }).then((r) => r.data),
  saveTemplate: (userId, name, levels, type = "rules", output_columns = [], column_filters = {}, sources = []) =>
    http.post(`/templates`, { user_id: userId, name, levels, type, output_columns, column_filters, sources }).then((r) => r.data),
  saveToolTemplate: (userId, name, tool) =>
    http.post(`/templates`, { user_id: userId, name, type: "tool", tool }).then((r) => r.data),
  importTool: (id, tool) => http.post(`/jobs/${id}/import-tool`, { tool }).then((r) => r.data),
  listTemplates: (userId) => http.get(`/templates`, { params: { user_id: userId } }).then((r) => r.data),
  deleteTemplate: (id) => http.delete(`/templates/${id}`).then((r) => r.data),
  exportJob: (id) => http.get(`/jobs/${id}/export-job`, { responseType: "blob" }).then((r) => r.data),
  importJob: (userId, data) => http.post(`/jobs/import`, { user_id: userId, data }).then((r) => r.data),
  publish: (id, password) => http.post(`/jobs/${id}/publish`, { password }).then((r) => r.data),
  commonInfo: () => http.get("/common").then((r) => r.data),
  requestRelease: (userId) => http.post("/common/request-release", { user_id: userId }).then((r) => r.data),
  clearRelease: (userId) => http.post("/common/clear-release", { user_id: userId }).then((r) => r.data),
  getModules: () => http.get("/modules").then((r) => r.data),
  forceEject: (userId) => http.post("/common/force-eject", { user_id: userId }).then((r) => r.data),
  formulaFunctions: () => http.get("/formula-functions").then((r) => r.data),
  commonAccess: (password, userId) =>
    http.post("/common/access", { password, user_id: userId }).then((r) => r.data),
  closeCommon: (id) => http.post(`/jobs/${id}/close`).then((r) => r.data),
  exportUrl: `${API}`,
  export: (id, format, columns, rows, extra = {}) =>
    http.post(`/jobs/${id}/export`, { format, columns, rows, ...extra }, { responseType: "blob" }).then((r) => r.data),
  split: (id, byCol, opts = {}) => {
    const fd = new FormData();
    fd.append("by_col", byCol);
    fd.append("file_format", opts.file_format || "excel");
    fd.append("index", opts.index ? "true" : "false");
    fd.append("index_fields", (opts.index_fields || []).join(","));
    fd.append("index_aggs", JSON.stringify(opts.index_aggs || []));
    return http.post(`/jobs/${id}/split`, fd, { responseType: "blob" }).then((r) => r.data);
  },
};

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 100);
}
